// @ts-strict-ignore
import { createContext, useContext } from 'react'

export const DeactivateXStreamContext = createContext(undefined)

export const useDeactivateXStream = (): boolean => {
    const isDeactivated = useContext(DeactivateXStreamContext)
    return isDeactivated
}
